/* ==========================================================================
   Composer son coffret
   Toute la donnee vient du Liquid, dans #cc-data (JSON). Ce fichier ne connait
   ni les prix ni les produits, il ne fait que l'etat et le rendu.
   ========================================================================== */
(function () {
  var racine = document.querySelector('[data-cc]');
  if (!racine) return;

  var noeudData = document.getElementById('cc-data');
  var CFG = JSON.parse(noeudData.textContent);
  var EPICES = CFG.epices;
  var MAX = CFG.max;
  var REMISE = CFG.remise;          /* 0.10 */
  var DEVISE = CFG.devise;          /* symbole, ex. "€" */

  /* La ligne marqueur est facturee : le bouton doit l'annoncer. Repli sur 0,10
     si la section ne renseigne pas le prix, valeur du produit "Frais de
     preparation" au 2026-08-25. */
  var MARQ = typeof CFG.marqueur_prix === 'number' ? CFG.marqueur_prix : 0.10;

  /* COFFRET EN UNE LIGNE (2026-09-26). Au paiement, onze lignes a plat (dix
     fioles et la ligne marqueur) ont ete refusees. Le coffret part desormais
     comme UN produit, « Les 10 a la Carte », dont chaque variante correspond a
     une valeur de fioles : cle = somme des fioles en centimes (son prix barre),
     valeur = [id de variante, prix remise]. Les epices voyagent dans les
     proprietes de la ligne. Plus de ligne marqueur, donc plus rien a facturer
     en plus. Table vide : on retombe sur l'ancien ajout en onze lignes. */
  var COFFRET = CFG.coffret || {};
  var UNE_LIGNE = Object.keys(COFFRET).length > 0;
  if (UNE_LIGNE) MARQ = 0;
  function varianteCoffret() {
    return COFFRET[String(Math.round(somme() * 100))] || null;
  }

  var sel = [];
  var filtre = 'TOUTES';
  var occupe = false;
  var aRemplacer = [];

  /* Le document, et non la racine de la section : depuis l'arrivee en fiche
     produit, un exemplaire du panneau vit dans la colonne de main-product,
     donc HORS de [data-cc]. Les attributs data-cc-* n'existent nulle part
     ailleurs dans le theme, la portee large ne peut rien accrocher d'autre. */
  var $ = function (s) { return document.querySelector(s) };
  var $$ = function (s) { return Array.prototype.slice.call(document.querySelectorAll(s)) };
  var parId = {};
  EPICES.forEach(function (e) { parId[e.id] = e });

  /* Convention de marque, deux regles : jamais d'espace entre le chiffre et
     l'euro, et jamais de centimes a zero. 49 EUR, pas 49,00 EUR. */
  function eur(n) {
    return n.toFixed(2).replace('.', ',').replace(',00', '') + DEVISE;
  }
  var eurCourt = eur;

  function somme() {
    var t = 0;
    for (var i = 0; i < sel.length; i++) t += parId[sel[i]].prix;
    return t;
  }

  /* Le prix remise, calcule comme le panier le calculera.

     La remise est une remise AUTOMATIQUE Shopify : elle s'applique ligne par
     ligne, jamais sur le total. Appliquer le taux sur le total donne un
     resultat different de quelques centimes, et c'est le panier qui a raison.

     Shopify TRONQUE le montant de la remise au centime inferieur, il ne
     l'arrondit pas. Mesure faite le 2026-08-25 sur un panier reel de dix
     lignes, remise de 11% :

       ligne a 5,60 : 560 x 0,11 = 61,6  ->  remise 61, ligne a 4,99
       ligne a 6,60 : 660 x 0,11 = 72,6  ->  remise 72, ligne a 5,88

     Avec Math.round, la remise passait a 62 et 73, soit UN CENTIME de trop par
     ligne. Sur dix lignes le bouton annoncait dix centimes de moins que le
     panier, et l'ecart ressemblait a s'y meprendre aux 0,10 EUR de frais de
     preparation, qui eux etaient bien comptes. floor() colle sur 10/10 lignes,
     round() sur 0/10. */
  function net() {
    /* En une ligne, le prix est celui de la variante : c'est lui que le panier
       prendra, a dix fioles. En cours de choix, estimation au taux reglé. */
    if (UNE_LIGNE) {
      var vc = sel.length === MAX ? varianteCoffret() : null;
      if (vc) return vc[1];
      return Math.round(somme() * 100 * (1 - REMISE)) / 100;
    }
    var t = 0;
    for (var i = 0; i < sel.length; i++) {
      var cents = Math.round(parId[sel[i]].prix * 100);
      t += cents - Math.floor(cents * REMISE);
    }
    return t / 100;
  }

  /* ---------------- filtres ---------------- */
  function compte(tag) {
    if (tag === 'TOUTES') return EPICES.length;
    return EPICES.filter(function (e) { return e.tags.indexOf(tag) !== -1 }).length;
  }
  function visible(e) {
    return filtre === 'TOUTES' || e.tags.indexOf(filtre) !== -1;
  }

  /* ---------------- recherche ----------------
     Elle s'AJOUTE au filtre de categorie, elle ne le remplace pas : chercher
     dans « Poivres » doit rester dans les poivres. Deux mecanismes qui se
     disputeraient `hidden` finiraient par s'effacer l'un l'autre, la condition
     est donc unique et combinee au moment du rendu.

     Sans accents ni casse : « sesame » doit trouver « 3 Sesames ». NFD separe
     la lettre de son accent, le bloc U+0300-U+036F retire les accents isoles. */
  var recherche = '';
  function sansAccents(t) {
    return (t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  /* Le NOM seul, comme la loupe de la page « Les épices ». L'accroche etait
     incluse pour trouver « couscous » ou « tajine », mais elle porte aussi des
     saveurs : « poivre » sortait la coriandre et le cumin, « délicatement
     poivrés ». Un visiteur qui tape un mot cherche une epice qui s'appelle
     ainsi (decision du 2026-09-29). */
  function correspond(carte) {
    if (!recherche) return true;
    var nom = carte.querySelector('.cc-card__n');
    return sansAccents(nom ? nom.textContent : carte.textContent).indexOf(recherche) !== -1;
  }

  /* ---------------- messages ---------------- */
  var toastT = null;
  /* $$ et non $ : depuis l'arrivee en fiche produit, il y a DEUX emplacements
     de message, celui de la colonne de la fiche et celui du panneau colle. Le
     premier du document n'est pas forcement celui que le visiteur a sous les
     yeux. */
  function message(txt) {
    $$('[data-cc-msg]').forEach(function (m) { m.textContent = txt; m.classList.add('cc-on') });
    var t = $('[data-cc-toast]');
    if (t) {
      t.textContent = txt;
      t.classList.add('cc-on');
    }
    /* Un seul minuteur pour tous les emplacements : le bandeau s'effaçait deja
       tout seul, les autres restaient jusqu'a la prochaine action et
       finissaient par decrire une situation revolue. Deux compteurs separes
       auraient fini par se desaccorder. */
    clearTimeout(toastT);
    toastT = setTimeout(effacerMessage, 3200);
  }
  function effacerMessage() {
    $$('[data-cc-msg]').forEach(function (m) { m.classList.remove('cc-on') });
    var t = $('[data-cc-toast]');
    if (t) t.classList.remove('cc-on');
  }
  function secouer(el) {
    if (!el) return;
    el.classList.remove('cc-shake');
    void el.offsetWidth;
    el.classList.add('cc-shake');
  }

  /* ---------------- rendus ---------------- */
  /* Les emplacements sont batis UNE fois, puis mis a jour en place. Les
     reconstruire a chaque clic recreait 20 balises img (panneau + feuille) :
     le thread principal restait occupe a les poser, la transition de la carte
     choisie ne trouvait plus de frame pour s'animer, et sa bordure arrivait
     une a deux secondes trop tard. Le point, lui, n'a pas de transition et
     passait tout de suite : d'ou l'impression que seule la bordure trainait. */
  function batirSlots(el) {
    var h = '';
    for (var i = 0; i < MAX; i++) {
      h += '<div class="cc-slot cc-slot--empty">'
        + '<button type="button" class="cc-slot__x" hidden>&times;</button>'
        + '<div class="cc-slot__cap"><span class="cc-slot__num">' + (i + 1) + '</span>'
        + '<img alt="" loading="lazy" width="80" height="80" hidden></div>'
        + '<div class="cc-slot__lab">libre</div>'
        + '</div>';
    }
    el.innerHTML = h;
  }

  function majSlots(el) {
    for (var i = 0; i < MAX; i++) {
      var sl = el.children[i];
      if (!sl) continue;
      var e = sel[i] ? parId[sel[i]] : null;
      var x = sl.querySelector('.cc-slot__x');
      var num = sl.querySelector('.cc-slot__num');
      var img = sl.querySelector('img');
      var lab = sl.querySelector('.cc-slot__lab');

      sl.className = 'cc-slot ' + (e ? 'cc-slot--full' : 'cc-slot--empty');
      if (e) {
        x.hidden = false;
        x.setAttribute('data-cc-del', e.id);
        x.setAttribute('aria-label', 'Retirer ' + e.nom);
        num.hidden = true;
        if (e.img) {
          if (img.getAttribute('src') !== e.img) img.setAttribute('src', e.img);
          img.hidden = false;
        } else {
          img.hidden = true;
        }
        lab.textContent = e.nom;
      } else {
        x.hidden = true;
        x.removeAttribute('data-cc-del');
        num.hidden = false;
        img.hidden = true;
        lab.textContent = 'libre';
      }
    }
  }

  /* A dix epices la ligne de prix disparait et le montant passe DANS le bouton :
     le prix cesse d'etre une information a surveiller pour devenir la promesse
     du clic. En dessous, le bouton n'est qu'un decompte, sans prix. */
  /* L'order bump coche s'ajoute au bouton, prix paye et prix barre. Meme calcul
     que window.getOrderBumpDelta du theme, refait ici plutot qu'appele : cette
     fonction-la vit dans un script qui se desactive sur les pages a abonnement,
     et le bouton du coffret n'a pas a dependre de cette condition.

     La remise du coffret ne touche PAS le presentoir : ses 19€ sont deja son
     prix remise, pose par la remise automatique du panier. On additionne donc
     un net a un net, et un barre a un barre. */
  function bumpDelta() {
    var d = { prix: 0, ref: 0 };
    /* Le PREMIER, et lui seul : les autres exemplaires sont ses copies, toutes
       cochees ensemble. Les additionner compterait le presentoir trois fois. */
    var b = $('.cc-bump order-bump');
    var coche = b && b.querySelector('[data-order-bump-toggle]');
    if (coche && coche.checked) {
      var p = parseInt(b.dataset.variantPriceCents || '0', 10) / 100;
      var c = parseInt(b.dataset.variantCompareCents || '0', 10) / 100;
      d.prix = p;
      d.ref = c > p ? c : p;
    }
    return d;
  }

  /* Spinner du theme, reproduit ici : les libelles de ces boutons sont
     reconstruits a chaque rendu, il doit donc faire partie du libelle. La
     regle .cta-charge de base.css le montre pendant l'attente et masque le
     reste. */
  var SPIN = '<span class="cta-charge__spin" aria-hidden="true">'
      + '<svg class="spinner" width="20" height="20" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">'
      + '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>'
      + '</svg></span>';

  function labelATC(n) {
    var reste = MAX - n;
    if (n === MAX) {
      var b = bumpDelta();
      var brut = somme();
      /* MARQ des deux cotes : la ligne marqueur n'est pas remisee, elle ne
         change donc pas l'economie affichee, seulement le montant a payer.

         Le prix barre reste dans le bouton, a la demande de Ganael. Les deux
         montants y sont cote a cote, ce qui suffit a lire la comparaison : la
         ligne << Vos N epices >> qui la legendait s'efface a dix, elle ne
         faisait plus que repeter le meme chiffre. */
      return '<span>Ajouter au panier · ' + eurCourt(net() + b.prix + MARQ)
        + ' <s class="cc-atc__ref">' + eurCourt(brut + b.ref + MARQ) + '</s></span>' + SPIN;
    }
    if (n === 0) return '<span>Choisissez vos ' + MAX + ' épices</span>' + SPIN;
    return '<span>Choisissez encore ' + reste + ' épice' + (reste > 1 ? 's' : '') + '</span>' + SPIN;
  }

  function render() {
    var n = sel.length;
    var brut = somme();
    var montant = net();
    /* Toujours << Vos N epices >>, y compris a dix. << Votre coffret >> laissait
       croire que le prix barre couvre aussi la pochette et l'entonnoir affiches
       juste au-dessus, alors qu'il ne compte que les fioles. Le libelle est ce
       qui rend la comparaison lisible : il doit nommer ce qu'elle mesure. */
    var lab = 'Vos ' + n + ' épice' + (n === 1 ? '' : 's') + ' :';

    /* pastilles */
    $$('[data-cc-pill]').forEach(function (p) {
      p.classList.toggle('cc-pill--on', p.dataset.ccPill === filtre);
    });

    /* cartes : on masque au lieu de reconstruire, les images restent en cache */
    var visibles = 0;
    $$('[data-cc-id]').forEach(function (c) {
      var e = parId[c.dataset.ccId];
      var ok = visible(e) && correspond(c);
      c.hidden = !ok;
      if (ok) visibles++;
      var pris = sel.indexOf(e.id) !== -1;
      c.classList.toggle('cc-card--on', pris);
      c.setAttribute('aria-pressed', pris ? 'true' : 'false');
    });
    var vide = $('[data-cc-vide]');
    if (vide) vide.hidden = visibles > 0;

    /* tiroir, panneau et feuille partagent le meme rendu */
    $$('[data-cc-slots]').forEach(majSlots);
    $$('[data-cc-cnt]').forEach(function (el) { el.textContent = n });
    $$('[data-cc-vider]').forEach(function (el) { el.hidden = n === 0 });
    /* La mention du tiroir suit le meme etat : invitation tant que rien n'est
       choisi, consigne des la premiere fiole. */
    $$('[data-cc-mention-vide]').forEach(function (el) { el.hidden = n > 0 });
    $$('[data-cc-mention-plein]').forEach(function (el) { el.hidden = n === 0 });
    /* Le conteneur des deux mentions se masque quand celle qui est visible n'a
       pas de texte : vide de son reglage, il ne laisserait qu'un filet sous
       rien. Il porte le filet, il doit donc disparaitre avec son contenu. */
    $$('.cc-tiroir__mention').forEach(function (m) {
      var quelqueChose = Array.prototype.some.call(m.children, function (el) {
        return !el.hidden && (el.textContent || '').trim() !== '';
      });
      m.hidden = !quelqueChose;
    });
    $$('[data-cc-hasard]').forEach(function (el) { el.hidden = n > 0 });
    /* Presente de zero a neuf, effacee a dix : la, le bouton juste en dessous
       porte deja le montant et le prix barre, la ligne repetait le meme
       chiffre a deux centimetres.

       A zero elle reste, et affiche 0€ sans prix barre. C'est un repere
       stable, qui dit ou lire le total avant meme la premiere fiole ; un
       reperage qui apparait en cours de route se remarque davantage. */
    $$('[data-cc-prixbloc]').forEach(function (el) { el.hidden = n === MAX });
    $$('[data-cc-prixlab]').forEach(function (el) { el.textContent = lab });
    $$('[data-cc-prix]').forEach(function (el) { el.textContent = eur(montant) });
    $$('[data-cc-prixref]').forEach(function (el) { el.textContent = n === 0 ? '' : eur(brut) });
    $$('[data-cc-atc]').forEach(function (el) { el.innerHTML = labelATC(n) });
    var satc = $('[data-cc-satc]');
    if (satc) {
      /* Meme decompte que le bouton de la barre : "Continuer a choisir" ne
         disait pas combien il en restait, alors que le tiroir est justement
         ouvert pour le savoir. L'action ne change pas, il referme la feuille. */
      var db = bumpDelta();
      satc.innerHTML = n === MAX
        ? '<span>Ajouter au panier · ' + eurCourt(montant + db.prix + MARQ) + ' <s class="cc-atc__ref">' + eurCourt(brut + db.ref + MARQ) + '</s></span>' + SPIN
        : labelATC(n);
    }

    /* la reglette */
    var seg = $('[data-cc-seg]');
    if (seg) {
      var s = '';
      for (var i = 0; i < MAX; i++) {
        var e = sel[i] ? parId[sel[i]] : null;
        /* la couleur du metachamp, pas l'image : a 8px de haut une photo ne
           montre qu'un eclat, la couleur se lit instantanement */
        s += '<span class="cc-bar__s' + (e ? ' cc-bar__s--on' : '') + '"'
          + (e && e.couleur ? ' style="background:' + e.couleur + '"' : '') + '></span>';
      }
      seg.innerHTML = s;
    }

    /* Deux images plus tard, la barre a fini de grandir ou de retrecir. */
    if (window.requestAnimationFrame && typeof mesurerBarre === 'function') {
      requestAnimationFrame(function () { requestAnimationFrame(mesurerBarre) });
    }
    racine.classList.toggle('cc-attente', n !== MAX);
    racine.classList.toggle('cc-complet', n === MAX);
    /* Repete sur body pour le panneau de la fiche, qui n'est pas dans .cc */
    document.body.classList.toggle('cc-attente', n !== MAX);
    document.body.classList.toggle('cc-complet', n === MAX);
  }

  /* ---------------- tirage au hasard ---------------- */
  /* Un tirage uniforme sur les 33 sort regulierement six graines et rien pour
     cuisiner. On tourne sur les familles : le coffret propose est plausible. */
  function familleDe(e) {
    var sous = ['MELANGES', 'POIVRES', 'SELS', 'PIMENTS', 'HERBES', 'GRAINES'];
    for (var i = 0; i < sous.length; i++) {
      if (e.tags.indexOf(sous[i]) !== -1) return sous[i];
    }
    return 'PURES';
  }
  function melanger(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }
  function tirageAuHasard() {
    var ordre = ['PURES', 'MELANGES', 'PIMENTS', 'HERBES', 'GRAINES', 'POIVRES', 'SELS'];
    var paniers = {};
    ordre.forEach(function (f) { paniers[f] = [] });
    /* Une epice epuisee ne peut pas entrer dans le coffret : la proposer
       ferait un tirage qu'il faut defaire a la main, et « Surprenez-moi »
       perdrait tout son interet. */
    EPICES.filter(function (e) { return e.dispo !== false; })
      .forEach(function (e) { paniers[familleDe(e)].push(e.id) });
    ordre.forEach(function (f) { melanger(paniers[f]) });
    var out = [];
    while (out.length < MAX) {
      var pris = 0;
      for (var i = 0; i < ordre.length; i++) {
        var f = ordre[i];
        if (out.length < MAX && paniers[f].length) { out.push(paniers[f].shift()); pris++ }
      }
      if (pris === 0) break;
    }
    return out;
  }

  /* ---------------- la feuille (mobile) ---------------- */
  function sheetOuverte() {
    var sh = $('[data-cc-sheet]');
    return sh && sh.classList.contains('cc-on');
  }
  function openSheet() {
    var sh = $('[data-cc-sheet]');
    if (!sh) return;
    sh.hidden = false;
    requestAnimationFrame(function () { sh.classList.add('cc-on') });
    var bar = $('[data-cc-bar]');
    if (bar) bar.classList.add('cc-ouvert');
  }
  /* La feuille n'existe qu'en telephone. La barre sert de temoin : masquee
     au-dessus de 1024px, elle y mesure zero. Evite de repeter le point de
     rupture dans le script, ou il finirait par diverger de la feuille. */
  function ouvrirSiMobile() {
    var bar = $('[data-cc-bar]');
    if (!bar || !bar.offsetHeight) return;
    if (!sheetOuverte()) openSheet();
  }
  function closeSheet() {
    var sh = $('[data-cc-sheet]');
    if (!sh || !sh.classList.contains('cc-on')) return;
    sh.classList.remove('cc-on');
    var bar = $('[data-cc-bar]');
    if (bar) bar.classList.remove('cc-ouvert');
    setTimeout(function () { if (!sh.classList.contains('cc-on')) sh.hidden = true }, 220);
  }
  /* Verrou de defilement, aligne sur les feuilles de choix de format.

     La fermeture au defilement de la page a ete retiree : elle confondait le
     doigt qui monte, geste de lecture ordinaire, avec le doigt qui descend
     pour repousser la feuille. Et la question ne se pose plus, puisque la page
     ne defile plus du tout tant que la feuille est ouverte.

     Par preventDefault et non par position: fixed sur body, qui obligerait a
     restituer la position a la fermeture et ferait sursauter la page. Le
     panneau garde son defilement propre quand son contenu deborde vraiment ;
     s'il tient en entier, rien ne bouge. */
  document.addEventListener('touchmove', function (ev) {
    if (!sheetOuverte()) return;
    var c = ev.target;
    var panel = c && c.closest ? c.closest('.cc-sheet__panel') : null;
    var defilable = panel && panel.scrollHeight > panel.clientHeight + 1;
    if (defilable) return;
    if (ev.cancelable) ev.preventDefault();
  }, { passive: false });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') closeSheet();
  });

  var drag = null;
  document.addEventListener('touchstart', function (ev) {
    var panel = ev.target.closest && ev.target.closest('.cc-sheet__panel');
    if (!panel || !sheetOuverte()) return;
    /* On n'amorce le geste que si la liste est en haut de son defilement.
       Sinon, tirer vers le bas au milieu de la liste deplacait la feuille au
       lieu de remonter dans les epices. Meme garde que sur les feuilles de
       choix de format. */
    if (panel.scrollTop > 0) return;
    drag = { panel: panel, y0: ev.touches[0].clientY, d: 0, t0: new Date().getTime() };
    panel.style.transition = 'none';
  }, { passive: true });
  document.addEventListener('touchmove', function (ev) {
    if (!drag) return;
    drag.d = Math.max(0, ev.touches[0].clientY - drag.y0);
    if (drag.d > 0 && ev.cancelable) ev.preventDefault();
    drag.panel.style.transform = 'translateY(' + drag.d + 'px)';
  }, { passive: false });
  document.addEventListener('touchend', function () {
    if (!drag) return;
    var d = drag.d, v = d / Math.max(1, new Date().getTime() - drag.t0);
    drag.panel.style.transition = '';
    drag.panel.style.transform = '';
    if (d > 90 || v > 0.5) closeSheet();
    drag = null;
  });

  /* ---------------- ajout au panier ---------------- */
  /* Deux temps : on pose les 10 lignes par l'API panier (ce qui preserve un
     panier deja commence, contrairement au permalien /cart/id:qty), puis on
     laisse Shopify appliquer le code de remise et nous deposer sur le panier. */
  function ajouterAuPanier() {
    if (occupe) return;
    if (sel.length !== MAX) {
      var r = MAX - sel.length;
      message('Il vous reste ' + r + ' épice' + (r > 1 ? 's' : '') + ' à choisir.');
      return;
    }
    occupe = true;
    $$('[data-cc-atc], [data-cc-satc]').forEach(function (b) { b.classList.add('cta-charge') });

    /* Un jeton par coffret : deux coffrets dans un meme panier restent deux
       lots distincts a l'affichage. _cc est masque (il commence par _), la
       propriete visible sert au client, sur la page de paiement comme dans
       son email de confirmation, ou le theme n'a plus la main. */
    var jeton = 'cc' + new Date().getTime().toString(36);
    var items;
    if (UNE_LIGNE) {
      var vc = varianteCoffret();
      if (!vc) {
        /* Une fiole a un prix que la grille des variantes ne couvre pas :
           on refuse plutot que d'encaisser un montant faux. Ajouter la
           variante de cette valeur sur « Les 10 a la Carte » suffit. */
        occupe = false;
        $$('[data-cc-atc], [data-cc-satc]').forEach(function (b) { b.classList.remove('cta-charge') });
        message('Ce coffret ne peut pas être ajouté pour le moment, écrivez-nous.');
        return;
      }
      /* _cce : les variantes des fioles, pour « Modifier la sélection ».
         _cci : nom et vignette de chaque fiole, pour le tiroir, qui ne sait
         pas retrouver un produit a partir d'un identifiant de variante.
         _Épices : la liste en clair. Masquee au paiement a la demande de
         Ganael (2026-09-26), elle reste lisible dans la commande cote admin,
         c'est elle qui sert a preparer le colis. */
      items = [{
        id: vc[0],
        quantity: 1,
        /* _Épices en PREMIER (2026-10-08) : l'admin affiche les proprietes
           dans l'ordre d'insertion, la liste a preparer passe donc avant les
           lignes techniques. Une epice par ligne et une ligne vide a la fin,
           pour la detacher du reste ; si l'admin ignorait les retours a la
           ligne, la virgule garde la liste lisible. */
        properties: {
          '_Épices': sel.map(function (id) { return parId[id].nom }).join(',' + String.fromCharCode(10)) + String.fromCharCode(10) + ' ',
          '_cc': jeton,
          '_ccu': window.location.pathname,
          '_cce': sel.map(function (id) { return parId[id].variante }).join(','),
          '_cci': sel.map(function (id) { return parId[id].nom + '¦' + (parId[id].img || '') }).join('|')
        }
      }];
    } else items = sel.map(function (id) {
      /* _ccu : la page d'ou vient ce coffret. Le tiroir s'en sert pour le
         lien Modifier, sans avoir a connaitre l'adresse de la page. */
      var props = { '_cc': jeton, '_ccu': window.location.pathname };
      if (CFG.jeton) props[CFG.etiquette || 'Coffret'] = CFG.jeton + ' · ' + MAX + ' épices';
      return { id: parId[id].variante, quantity: 1, properties: props };
    });

    /* ---------------- la ligne marqueur ----------------
       ATTENTION : ce bloc a deja ete efface DEUX FOIS par une sauvegarde faite
       cote admin Shopify depuis une copie perimee du fichier. Si tu edites ce
       fichier dans l'editeur de code de l'admin, recharge-le d'abord, sinon tu
       remets le bug de remise decrit ci-dessous.

       Onzieme ligne du coffret, a 0 EUR, produit "Coffret compose".

       Elle existe pour UNE raison : la remise du presentoir est un Achetez X
       obtenez Y. Quand son X etait "10 articles de la collection Les Epices",
       elle CONSOMMAIT les dix lignes d'epices du coffret, et Shopify n'applique
       qu'une seule remise produit sur des articles deja consommes : les 10 %
       du coffret sautaient des que le client ajoutait le presentoir. Son
       coffret passait de 56,70 a 67 EUR sous ses yeux.

       Le marqueur donne au presentoir un article a consommer qui n'est PAS une
       epice. Son X est desormais "1 produit de la collection Declencheur
       presentoir", qui contient les coffrets catalogue et ce produit. Les dix
       lignes d'epices restent libres, les 10 % s'appliquent, les deux remises
       se cumulent. C'est aussi ce qui permet une remise presentoir unique pour
       le catalogue ET le compose.

       Elle porte le meme jeton _cc que les epices : le tiroir la replie donc
       dans le bloc du coffret, la croix l'emporte avec le lot, et la pastille
       du header continue de compter 1 article. _ccm la distingue des epices
       pour que le tiroir ne la compte ni ne l'affiche parmi les vignettes.

       L'identifiant vit ici plutot que dans un reglage de section : un reglage
       vide casserait l'ajout sans rien dire. Si le produit est recree dans
       l'admin, c'est cette ligne qu'il faut mettre a jour. */
    /* L'order bump du panneau : coche, il part avec le coffret. Il n'est
       visible qu'a dix sur dix, et l'ajout ne se declenche qu'a dix : sa case
       ne peut donc pas etre cochee sans avoir ete vue. Ligne ordinaire, sans
       jeton de coffret : le presentoir n'est pas dans le lot, il s'ajoute a
       cote et le tiroir du panier ne doit pas le replier dedans. */
    var bump = document.querySelector('.cc-bump order-bump');
    var bumpCoche = bump && bump.querySelector('[data-order-bump-toggle]');
    if (bump && bumpCoche && bumpCoche.checked && bump.dataset.variantId) {
      items.push({ id: Number(bump.dataset.variantId), quantity: 1 });
    }

    var MARQUEUR = CFG.marqueur || 54358257893689;
    if (MARQUEUR && !UNE_LIGNE) {
      items.push({
        id: MARQUEUR,
        quantity: 1,
        properties: { '_cc': jeton, '_ccu': window.location.pathname, '_ccm': '1' }
      });
    }

    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender
      ? drawer.getSectionsToRender().map(function (x) { return x.id })
      : [];

    var racineUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(racineUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Ajout impossible') });
        return r.json();
      })
      .then(function (etat) {
        /* en edition, l'ancien coffret part maintenant que le nouveau est pose :
           dans cet ordre, un echec de l'ajout ne laisse pas le panier vide */
        if (aRemplacer.length) {
          var maj = {};
          aRemplacer.forEach(function (k) { maj[k] = 0 });
          aRemplacer = [];
          return fetch(racineUrl + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: maj, sections: sections, sections_url: window.location.pathname })
          }).then(function (r) { return r.json() });
        }
        return etat;
      })
      .then(function (etat) {
        sel = [];
        occupe = false;
        $$('[data-cc-atc], [data-cc-satc]').forEach(function (b) { b.classList.remove('cta-charge') });
        closeSheet();
        render();

        /* Le tiroir se recharge avec les sections que Shopify vient de rendre,
           donc sans rechargement de page ni detour par /cart. */
        if (drawer && etat && etat.sections) {
          drawer.renderContents(etat);
        } else if (drawer && drawer.open) {
          drawer.open();
        } else {
          window.location.href = racineUrl + 'cart';
        }
      })
      .catch(function (e) {
        occupe = false;
        $$('[data-cc-atc], [data-cc-satc]').forEach(function (b) { b.classList.remove('cta-charge') });
        message(e.message || 'Ajout impossible, réessayez.');
      });
  }

  /* ---------------- retour a la barre de filtres ---------------- */
  /* Changer de famille sans bouger la vue laisse le visiteur devant du vide des
     que la nouvelle famille est plus courte que sa position de defilement : une
     famille a un seul produit s'affiche tout en haut, donc hors ecran. On
     revient a la place naturelle de la barre, et jamais vers le bas. */
  /* Emmener le visiteur au catalogue, la barre de filtres collee en haut de
     l'ecran. Meme arrivee que lorsqu'on change de famille, dans les deux sens :
     depuis la fiche on descend, depuis le catalogue on remonte. */
  function allerAuxFiltres() {
    var repere = $('[data-cc-sentinelle]');
    if (!repere) return;
    var cible = repere.getBoundingClientRect().top + window.pageYOffset + 1;
    if (Math.abs(window.pageYOffset - cible) < 2) return;
    var entete = document.querySelector('sticky-header');
    if (entete) entete.dispatchEvent(new CustomEvent('preventHeaderReveal'));
    tenir(cible);
  }

  function remonter() {
    var repere = $('[data-cc-sentinelle]');
    if (!repere) return;
    /* +1 px : a la position exacte la sentinelle reste visible d'un cheveu, et
       l'etat colle de la barre clignoterait. */
    var cible = repere.getBoundingClientRect().top + window.pageYOffset + 1;
    if (window.pageYOffset <= cible) return;
    /* L'en-tete du theme se devoile au defilement vers le haut et recouvrirait
       la barre : l'evenement du theme lui demande de rester cache. */
    var entete = document.querySelector('sticky-header');
    if (entete) entete.dispatchEvent(new CustomEvent('preventHeaderReveal'));
    tenir(cible);
  }

  /* Un seul scrollTo ne tient pas a tous les coups : sur mobile l'elan du
     defilement continue apres le doigt et emporte la page juste apres le saut.
     On maintient donc la position image par image pendant une demi-seconde, le
     temps que l'elan s'eteigne. Un geste franc (doigt pose, clic, touche) rend
     la main aussitot ; un nouveau clic sur une pastille remplace le maintien
     en cours. */
  var maintien = 0;
  function tenir(cible) {
    var moi = ++maintien;
    var fin = Date.now() + 500;
    var lache = function () { if (moi === maintien) fin = 0 };
    var gestes = ['touchstart', 'mousedown', 'keydown'];
    gestes.forEach(function (g) { window.addEventListener(g, lache, { passive: true }) });

    /* theme.liquid pose scroll-behavior: smooth sur html. Chaque rappel de
       position relancait donc une animation douce que le rappel suivant
       interrompait : la page reptait pendant une demi-seconde, puis filait d'un
       coup quand la boucle s'arretait. On force le saut sec pendant le
       maintien, et on rend au theme son reglage a la fin. */
    var html = document.documentElement;
    var avant = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';

    (function boucle() {
      if (moi === maintien && Date.now() < fin) {
        window.scrollTo(0, cible);
        requestAnimationFrame(boucle);
        return;
      }
      gestes.forEach(function (g) { window.removeEventListener(g, lache) });
      /* Seul le dernier maintien rend la main : un nouveau clic pendant
         celui-ci a deja repris le reglage a son compte. */
      if (moi === maintien) html.style.scrollBehavior = avant;
    })();
  }

  /* ---------------- interactions ---------------- */
  /* La frappe dans la loupe. Delegue comme le reste : la barre est rendue par
     la section, le script ne la cherche jamais au demarrage. */
  document.addEventListener('input', function (ev) {
    if (!ev.target || !ev.target.matches('[data-cc-recherche-champ]')) return;
    recherche = sansAccents(ev.target.value).trim();
    render();
  });

  document.addEventListener('keydown', function (ev) {
    if (!ev.target || !ev.target.matches('[data-cc-recherche-champ]')) return;
    if (ev.key !== 'Escape') return;
    var boite = ev.target.closest('[data-cc-recherche]');
    if (boite) {
      boite.classList.remove('est-ouverte');
      if (boite.parentElement) boite.parentElement.classList.remove('recherche-ouverte');
      var b = boite.querySelector('[data-cc-recherche-bouton]');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
    ev.target.value = '';
    recherche = '';
    render();
  });

  /* Cocher le presentoir quelque part le coche partout, et change le montant
     des boutons : on aligne les cases, puis on redessine. */
  document.addEventListener('change', function (ev) {
    if (!ev.target || !ev.target.matches('[data-order-bump-toggle]')) return;
    var etat = ev.target.checked;
    $$('.cc-bump [data-order-bump-toggle]').forEach(function (c) { c.checked = etat });
    render();
  });

  document.addEventListener('click', function (ev) {
    var t = ev.target;

    if (t.closest('[data-cc-sheet-close]')) { closeSheet(); return }

    if (t.closest('[data-cc-satc]')) {
      if (sel.length < MAX) closeSheet(); else ajouterAuPanier();
      return;
    }
    if (t.closest('[data-cc-atc]')) {
      var cta = t.closest('[data-cc-atc]');
      if (sel.length < MAX) {
        /* Depuis le panneau de la fiche, en haut de page : le visiteur n'a pas
           encore vu le catalogue, lui secouer un bouton ne lui apprend rien.
           On l'emmene aux filtres, exactement ou le depose un changement de
           famille. Depuis le panneau colle, la grille est deja sous ses yeux :
           la secousse et le decompte gardent tout leur sens. */
        if (cta.closest('.cc-fiche__panneau')) {
          allerAuxFiltres();
          return;
        }
        var r = MAX - sel.length;
        secouer(cta);
        message('Il vous reste ' + r + ' épice' + (r > 1 ? 's' : '') + ' à choisir.');
      } else {
        ajouterAuPanier();
      }
      return;
    }
    if (t.closest('[data-cc-voir]')) {
      if (sheetOuverte()) closeSheet(); else openSheet();
      return;
    }

    var croix = t.closest('[data-cc-del]');
    if (croix) {
      var idd = croix.dataset.ccDel;
      sel = sel.filter(function (x) { return x !== idd });
      effacerMessage();
      render();
      return;
    }
    if (t.closest('[data-cc-hasard]')) { sel = tirageAuHasard(); effacerMessage(); render(); return }
    if (t.closest('[data-cc-vider]')) { sel = []; effacerMessage(); render(); return }

    /* Un emplacement vide est une invitation : le clic fait ce que ferait le
       bouton juste en dessous de lui, la ou il se trouve. Depuis la fiche, il
       emmene au catalogue ; depuis la feuille du bas, il la referme sur la
       grille. Dans le panneau colle, il ne fait rien : la grille y est deja a
       l'ecran, et son bouton n'y mene nulle part non plus. */
    var vide = t.closest('.cc-slot--empty');
    if (vide) {
      if (vide.closest('.cc-sheet')) { closeSheet(); return }
      if (vide.closest('.cc-fiche__panneau')) { allerAuxFiltres(); return }
    }

    var pill = t.closest('[data-cc-pill]');
    if (pill) { filtre = pill.dataset.ccPill; render(); remonter(); return }

    /* La croix, et elle seule, referme. La classe part aussi de la RANGEE :
       c'est elle qui efface ses pastilles et cede toute sa largeur au champ,
       et une classe posee sur un enfant ne peut pas atteindre ses freres. */
    var croix = t.closest('[data-cc-recherche-fermer]');
    if (croix) {
      var b = croix.closest('[data-cc-recherche]');
      var c = b.querySelector('[data-cc-recherche-champ]');
      b.classList.remove('est-ouverte');
      if (b.parentElement) b.parentElement.classList.remove('recherche-ouverte');
      b.querySelector('[data-cc-recherche-bouton]').setAttribute('aria-expanded', 'false');
      c.value = '';
      recherche = '';
      render();
      return;
    }

    var loupe = t.closest('[data-cc-recherche-bouton]');
    if (loupe) {
      var boite = loupe.closest('[data-cc-recherche]');
      var champ = boite.querySelector('[data-cc-recherche-champ]');
      if (boite.classList.contains('est-ouverte')) {
        champ.focus();
      } else {
        /* La recherche porte sur TOUTES les epices. Rester dans la categorie
           courante ferait repondre « aucun resultat » a une epice pourtant
           presente au catalogue, et rien a l'ecran n'expliquerait pourquoi.
           On repasse donc sur « Toutes » : render() rallume la bonne pastille,
           le visiteur voit le filtre se relacher. */
        filtre = 'TOUTES';
        boite.classList.add('est-ouverte');
        if (boite.parentElement) boite.parentElement.classList.add('recherche-ouverte');
        loupe.setAttribute('aria-expanded', 'true');
        render();
        champ.focus();
      }
      return;
    }

    var card = t.closest('[data-cc-id]');
    /* Un bouton `disabled` n'emet deja pas de clic ; la garde couvre le cas ou
       la carte cesserait un jour d'etre un <button>. */
    if (card && (card.disabled || card.getAttribute('aria-disabled') === 'true')) return;
    if (card) {
      var id = card.dataset.ccId;
      if (sel.indexOf(id) !== -1) {
        sel = sel.filter(function (x) { return x !== id });
        effacerMessage();
      } else if (sel.length >= MAX) {
        message('Coffret complet. Retirez une épice pour en ajouter une autre.');
        $$('[data-cc-panelbox]').forEach(secouer);
        secouer($('[data-cc-bar]'));
        /* Le refus doit se voir : la feuille s'ouvre avec le message, et
           montre du meme coup les dix epices parmi lesquelles choisir celle a
           retirer. */
        ouvrirSiMobile();
        return;
      } else {
        sel.push(id);
        effacerMessage();
        /* Dixieme epice : le coffret vient d'etre complete, la question
           suivante est « est-ce bien ça ? ». On montre la selection sans
           attendre qu'on la demande. */
        if (sel.length === MAX) ouvrirSiMobile();
      }
      render();
    }
  });

  /* compteurs des pastilles, calcules une fois */
  $$('[data-cc-pill]').forEach(function (p) {
    var c = p.querySelector('.cc-pill__c');
    if (c) c.textContent = compte(p.dataset.ccPill);
  });

  /* ---------------- barre de filtres collee ---------------- */
  /* Le filet du bas n'apparait que lorsque la barre est reellement collee.
     Une sentinelle d'un pixel la precede : tant qu'elle est visible, la barre
     est a sa place. Aucun ecouteur de scroll, l'observateur ne se reveille
     qu'au franchissement. */
  var sentinelle = $('[data-cc-sentinelle]');
  var barre = $('[data-cc-barre]');
  if (sentinelle && barre && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entrees) {
      barre.classList.toggle('cc-collee', !entrees[0].isIntersecting);
    }, { threshold: 0 }).observe(sentinelle);
  }

  /* ---------------- l'order bump, partout ou il y a un bouton ----------------
     Il est declare une seule fois, dans le bloc de la fiche produit : c'est la
     qu'il se regle. On le recopie au-dessus des autres boutons d'ajout, le
     panneau colle du catalogue et la feuille du bas, pour qu'il ne manque
     jamais la ou l'achat se decide. Une copie du DOM et non un second bloc de
     reglages : la mise en forme suit, elle est portee par l'id du bloc.
     Les cases restent alignees entre elles, et seul le premier exemplaire
     compte dans le prix. */
  var bumpSource = $('.cc-bump order-bump');
  if (bumpSource) {
    $$('.cc-atc, .cc-sheet__atc, .cc-bar__btn').forEach(function (bouton) {
      if (bouton.closest('.cc-fiche__panneau')) return;
      var voisin = bouton.previousElementSibling;
      if (voisin && voisin.classList.contains('cc-bump')) return;
      /* Dans la barre collante, la copie ne se montre qu'a dix sur dix : la
         classe est posee ici, l'affichage est decide par la feuille de style
         a partir de `cc-complet`. */
      var dansLaBarre = !!bouton.closest('.cc-bar');
      var enveloppe = document.createElement('div');
      enveloppe.className = dansLaBarre ? 'cc-bump cc-bump--barre' : 'cc-bump';
      /* Une question introduit le bump dans les COPIES seulement. Sur la fiche
         produit ce sont les trois arguments qui jouent ce role ; ici il n'y en
         a pas, et sans elle le bump a la meme forme que les blocs « INCLUS »
         juste au-dessus, qui ne sont pas actionnables : l'oeil apprend que
         cette famille de blocs est decorative et saute le troisieme. */
      /* La phrase introduit le presentoir partout, barre comprise : sans elle
         il a la meme forme que les blocs << INCLUS >> qui le precedent, et
         l'oeil le prend pour un troisieme bloc decoratif. Elle nomme le plan
         de travail et non le rangement : le presentoir sert a voir les epices,
         pas a les cacher. */
      var question = document.createElement('p');
      question.className = 'cc-bump__q';
      question.textContent = 'Et pour votre plan de travail ?';
      enveloppe.appendChild(question);
      enveloppe.appendChild(bumpSource.cloneNode(true));
      bouton.parentNode.insertBefore(enveloppe, bouton);
    });
  }

  /* La barre est fixe : la page doit lui reserver sa hauteur, sinon son
     dernier bloc passe dessous. On la mesure plutot que de l'ecrire en dur,
     elle grandit quand le presentoir apparait a dix sur dix.

     Zero quand la barre est masquee, au-dessus de 1024px : la classe tombe et
     le rembourrage avec elle, sans avoir a repeter le point de rupture ici. */
  function mesurerBarre() {
    var bar = $('[data-cc-bar]');
    if (!bar) return;
    /* Masquee, elle ne recouvre rien : la page n'a plus a lui reserver de
       hauteur, sinon un vide suit le pied de page sans rien dedans. */
    var h = bar.classList.contains('cc-bar--masquee') ? 0 : bar.offsetHeight;
    document.body.classList.toggle('cc-avec-barre', h > 0);
    document.documentElement.style.setProperty('--cc-bar-h', h + 'px');
  }
  window.addEventListener('resize', mesurerBarre);

  /* ---------------- seuil d'apparition de la barre ----------------
     Le bouton d'ajout du panneau de la fiche sert de repere : tant qu'il est
     a l'ecran, la barre doublerait une commande deja a portee de pouce. Elle
     n'apparait qu'une fois ce bouton passe AU-DESSUS de l'ecran.

     Sur la page composeur ce panneau n'existe pas : sans repere, pas de
     condition, la barre reste visible comme avant. */
  (function () {
    var bar = $('[data-cc-bar]');
    var repere = $('.cc-fiche__panneau .cc-atc');
    if (!bar || !repere || !window.IntersectionObserver) return;

    bar.classList.add('cc-bar--masquee');
    new IntersectionObserver(function (entrees) {
      var e = entrees[0];
      /* Au-dessus de l'ecran : le bas du repere est passe sous zero. Le test
         sur la position et non sur la seule visibilite evite de montrer la
         barre quand on est REMONTE au-dessus du bouton. */
      var passe = !e.isIntersecting && e.boundingClientRect.bottom < 0;
      bar.classList.toggle('cc-bar--masquee', !passe);
      mesurerBarre();
    }, { threshold: 0 }).observe(repere);
  })();

  $$('[data-cc-slots]').forEach(batirSlots);
  render();
  mesurerBarre();

  /* ---------------- reprise d'un coffret existant ---------------- */
  /* Arrive avec ?edit=<jeton> depuis le tiroir : on relit le panier, on
     re-selectionne les memes epices, et on retient les lignes a retirer pour
     que valider REMPLACE le coffret au lieu d'en ajouter un second. */
  var edit = (window.location.search.match(/[?&]edit=([^&]+)/) || [])[1];
  if (edit) {
    edit = decodeURIComponent(edit);
    var parVariante = {};
    EPICES.forEach(function (e) { parVariante[e.variante] = e.id });
    fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json() })
      .then(function (panier) {
        var repris = [];
        (panier.items || []).forEach(function (l) {
          var p = l.properties || {};
          if (p._cc !== edit) return;
          aRemplacer.push(l.key);
          /* Coffret en une ligne : les fioles sont dans _cce, pas dans les lignes */
          var ids = p._cce ? String(p._cce).split(',') : [l.id];
          ids.forEach(function (vid) {
            var id = parVariante[vid];
            if (id && repris.indexOf(id) === -1) repris.push(id);
          });
        });
        if (repris.length) {
          sel = repris.slice(0, MAX);
          render();
        }
      })
      .catch(function () { /* panier illisible : on laisse la page vierge */ });
  }
})();
